<div class="toggle-switch">
  <label
    (click)="toggleChecked(); $event.stopPropagation()"
    [ngClass]="{'checked' : checked}">
    <span></span>
  </label>
</div>
